import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { LOGGED_USER } from "../../variables/constants";
import axiosInstance from "../../variables/api/axiosInstance";
import SDIModal from "../../components/ui/SDIModal";

const AddIntermediaire = ({ show, handleClose, editMode, organisme }) => {
  const getInitialFormData = () => ({
    nom: "",
    prenom: "",
    genre: "",
    fonction: "",
    adresseResidence: "",
    telephone: "",
    email: "",
    type: "",
    codeIntermediaire: "",
  });

  const [formData, setFormData] = useState(getInitialFormData());

  const [loading, setLoading] = useState(false);
  const [mailExists, setMailExists] = useState(false);
  const [codeIntermediaireExists, setCodeIntermediaireExists] = useState(false);

  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setFormData(getInitialFormData());
    setErrors({});
    setMailExists(false);
    setCodeIntermediaireExists(false);
  };

  const closeModal = () => {
    resetForm();
    handleClose && handleClose();
  };

  useEffect(() => {
    if (!show && !editMode) {
      resetForm();
    }
  }, [show, editMode]);

  const assignDefaultCommissionRates = async (newIntermediaire) => {
    try {
      const organismeCode = newIntermediaire?.organisme?.code || organisme?.code || LOGGED_USER?.profil?.organisme?.code;
      const intermediaireType = (newIntermediaire?.type || formData.type || "").toLowerCase();

      if (!newIntermediaire?.codeId || !organismeCode || !intermediaireType) {
        return;
      }

      const { data } = await axiosInstance.get(`/api/taux-commission`);
      const defaultRates = (data || []).filter((tc) => {
        const tcType = (typeof tc?.typeIntermediaire === "string"
          ? tc.typeIntermediaire
          : tc?.typeIntermediaire?.libelle || tc?.typeIntermediaire?.nom || ""
        ).toLowerCase();
        const tcOrgCode = tc?.organisme?.code || tc?.organisme?.codeOrganisme;
        return tcType === intermediaireType && tcOrgCode === organismeCode;
      });

      if (!defaultRates.length) {
        return;
      }

      const payload = {
        intermediaireId: newIntermediaire.codeId,
        commissions: defaultRates.map((tc) => ({
          categorie: tc.categorie,
          taux: tc.taux,
        })),
      };

      await axiosInstance.put(`/api/intermediaire/taux-commission`, payload);
    } catch (error) {
      console.log(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email" && name.length > 3) {
      checkIfEmailExists(value);
    }
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = (email) => {
    const newErrors = {};
    const phonePattern = /^(22|90|91|92|93|96|98|99|70|71|79)\d{6}$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.nom) newErrors.nom = "Nom requis";
    if (formData.nom.length < 3)
      newErrors.nom = "Le nom doit avoir au moins 2 caractères";
    if (!formData.prenom) newErrors.prenom = "Prénom requis";
    if (formData.prenom.length < 3)
      newErrors.prenom = "Le prénom doit avoir au moins 2 caractères";
    if (!formData.genre) newErrors.genre = "Genre requis";
    if (!formData.codeIntermediaire)
      newErrors.codeIntermediaire = "Code intermédiaire requis";
    if (!formData.type)
      newErrors.type = "Veuillez sélectionner le type d'intermédiaire";
    if (!formData.telephone) newErrors.telephone = "Numéro de téléphone requis";
    if (!phonePattern.test(formData.telephone))
      newErrors.telephone = "Numéro de téléphone invalide";
    // if (!email) newErrors.email = "Adresse mail requis";
    if (email && !emailPattern.test(email))
      newErrors.email = "L'adresse email n'est pas valide.";
    // Add more validation rules if needed
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const checkIfEmailExists = (email) => {
    axiosInstance
      .get(`/api/utilisateur/check/${email}`)
      .then((res) => {
        if (res.data)
          toast(
            "Il existe déjà un utilisateur avec cette adresse mail dans le système!"
          );
        setMailExists(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkIfCodeIntermediaireExists = (code) => {
    let org = organisme ? organisme : LOGGED_USER.profil.organisme;
    axiosInstance
      .get(`/api/intermediaire/code-check/${code}/${org.code}`)
      .then((res) => {
        if (res.data)
          toast(
            "Il existe déjà un intermediaire avec ce code dans la compagnie!"
          );
        setCodeIntermediaireExists(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let v = formData.email;
    if (organisme?.domaine) {
      v += "@" + organisme?.domaine;
    }
    checkIfEmailExists(v);
    checkIfCodeIntermediaireExists(formData.codeIntermediaire);

    if (validateForm(v) && !mailExists && !codeIntermediaireExists) {
      const user = {
        nom: formData.nom,
        prenom: formData.prenom,
        email: v,
        contact: [formData.telephone],
        password: formData.password,
        genre: formData.genre,
        adresse: formData.adresseResidence,
        fonction: "INTERMEDIAIRE",
        type: formData.type,
        typePersonne: "PHYSIQUE",
        organisme: organisme ? organisme : LOGGED_USER.profil.organisme,
        username: formData.codeIntermediaire,
      };

      let agenceCode = organisme
        ? organisme?.code
        : LOGGED_USER.profil.organisme.code;
      axiosInstance
        .post(`/api/intermediaire/new/${agenceCode}`, JSON.stringify(user))
        .then(async (res) => {
          try {
            await assignDefaultCommissionRates(res.data);
          } catch (error) {
            console.log(error);
          }
          toast("Intermediaire ajouté avec succès");
          resetForm();
          closeModal();
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast("Erreur lors de l'ajout de l'intermédiaire");
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <SDIModal
      open={show}
      onCancel={closeModal}
      footer={null}
      width={900}
      destroyOnClose
    >
      <button
        type="button"
        className="btn-close btn-primary"
        onClick={closeModal}
        aria-label="Close"
      ></button>
      <div className="text-center mb-6">
        <h4 className="address-title mb-2">
          {editMode ? "Modifier l'" : "Ajouter un"} intermédiaire
        </h4>
        <p className="address-subtitle">
          {editMode ? "Modifier l'" : "Ajouter un nouvel"} intermédiaire de
          l'agence
        </p>
      </div>
      <form id="addNewAddressForm" className="row g-12">
        <div className="col-sm-6">
          <label className="form-label" htmlFor="nom">
            Nom
          </label>
          <input
            type="text"
            id="nom"
            name="nom"
            className={`form-control ${errors.nom ? "is-invalid" : ""}`}
            placeholder="Entrez le nom"
            value={formData.nom}
            onChange={handleInputChange}
          />
          {errors.nom && <div className="invalid-feedback">{errors.nom}</div>}
        </div>
        <div className="col-sm-6">
          <label className="form-label" htmlFor="prenom">
            Prénom(s)
          </label>
          <input
            type="text"
            id="prenom"
            name="prenom"
            className={`form-control ${errors.prenom ? "is-invalid" : ""}`}
            placeholder="Entrez le prénom"
            value={formData.prenom}
            onChange={handleInputChange}
          />
          {errors.prenom && (
            <div className="invalid-feedback">{errors.prenom}</div>
          )}
        </div>
        <div className="col-sm-6" style={{ marginTop: "16px" }}>
          <label className="form-label" htmlFor="codeIntermediaire">
            Code de l'intermédiaire
          </label>
          <input
            type="text"
            id="codeIntermediaire"
            name="codeIntermediaire"
            className={`form-control ${
              errors.codeIntermediaire ? "is-invalid" : ""
            }`}
            placeholder="Entrez le code intermédiaire"
            value={formData.codeIntermediaire}
            onChange={(e) => {
              handleInputChange(e);
              checkIfCodeIntermediaireExists(e.target.value);
            }}
          />
          {errors.codeIntermediaire && (
            <div className="invalid-feedback">{errors.codeIntermediaire}</div>
          )}
        </div>
        <div className="col-sm-6" style={{ marginTop: "16px" }}>
          <label className="form-label" htmlFor="genre">
            Genre
          </label>
          <select
            id="genre"
            name="genre"
            className={`form-control w-100 ${errors.genre ? "is-invalid" : ""}`}
            data-style="btn-default"
            value={formData.genre}
            onChange={handleInputChange}
          >
            <option value="">Selectionnez le genre</option>
            <option value="MASCULIN">Masculin</option>
            <option value="FEMININ">Féminin</option>
          </select>
          {errors.genre && (
            <div className="invalid-feedback">{errors.genre}</div>
          )}
        </div>
        <div className="col-sm-6" style={{ marginTop: "16px" }}>
          <label className="form-label" htmlFor="type">
            Type d'intermédiaire
          </label>
          <select
            id="type"
            name="type"
            className={`form-control w-100 ${errors.type ? "is-invalid" : ""}`}
            data-style="btn-default"
            value={formData.type}
            onChange={handleInputChange}
          >
            <option value="">Selectionnez le type d'intermédiaire</option>
            <option value="AGENT_GENERAL">Agent général</option>
            <option value="APPORTEUR_REGULIER">Apporteur régulier</option>
            <option value="APPORTEUR_OCCASIONNEL">Apporteur occasionnel</option>
          </select>
          {errors.type && <div className="invalid-feedback">{errors.type}</div>}
        </div>
        <div className="col-sm-6" style={{ marginTop: "16px" }}>
          <label className="form-label" htmlFor="email">
            Adresse mail
          </label>
          <div className="input-group input-group-merge">
            <input
              type="text"
              id="email"
              name="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="Veuillez renseigner l'adresse mail"
              value={formData.email}
              onChange={handleInputChange}
            />
            {organisme?.domaine && (
              <span className="input-group-text" id="basic-addon33">
                @{organisme?.domaine}
              </span>
            )}
            {errors.email && (
              <div className="invalid-feedback">{errors.email}</div>
            )}
          </div>
        </div>
        <div className="col-sm-6" style={{ marginTop: "16px" }}>
          <label className="form-label" htmlFor="telephone">
            Numéro de téléphone
          </label>
          <div className="input-group">
            <span className="input-group-text">TG (+228)</span>
            <input
              type="text"
              id="telephone"
              name="telephone"
              placeholder="00 00 00 00"
              className={`form-control phone-number-mask ${
                errors.telephone ? "is-invalid" : ""
              }`}
              value={formData.telephone}
              onChange={handleInputChange}
            />
          </div>
          {errors.telephone && (
            <div className="invalid-feedback">{errors.telephone}</div>
          )}
        </div>
        <div className="col-sm-6" style={{ marginTop: "16px" }}>
          <label className="form-label" htmlFor="adresseResidence">
            Adresse de résidence
          </label>
          <textarea
            id="adresseResidence"
            name="adresseResidence"
            className="form-control bootstrap-maxlength-example"
            maxLength="255"
            placeholder="L'adresse de résidence de l'intermédiaire"
            value={formData.adresseResidence}
            onChange={handleInputChange}
          ></textarea>
        </div>
        <div className="col-12 text-center">
          <button
            onClick={(e) => handleSubmit(e)}
            className="btn btn-primary me-3"
            disabled={loading}
          >
            {loading && (
              <span
                className="spinner-grow me-1"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {loading ? `Enregistrement...` : `Enregistrer`}
          </button>
          <button
            type="reset"
            className="btn btn-label-secondary"
            onClick={closeModal}
          >
            Annuler
          </button>
        </div>
      </form>
    </SDIModal>
  );
};

export default AddIntermediaire;
